module.exports = __webpack_public_path__ + "img/1.2af0d718.jpeg";